import React, { useState, useEffect } from 'react';
import {
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    Button,
    CircularProgress,
    Dialog
} from '@material-ui/core'
import { TextValidator } from 'react-material-ui-form-validator'
import { SubTitle, ValidatorForm } from 'app/components/LoonsLabComponents'
import { Autocomplete } from '@material-ui/lab'
import { Alert } from '@material-ui/lab'
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { makeStyles } from '@material-ui/core/styles'
import history from 'history.js'
import clsx from 'clsx'
import useAuth from 'app/hooks/useAuth'
import localStorageService from 'app/services/localStorageService'
import * as appConst from '../../../../appconst'
import EmployeeServices from 'app/services/EmployeeServices'
import ClinicService from 'app/services/ClinicService'
import { uniqBy } from 'lodash'
import { getEnv } from 'envConfig'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    cardHolder: {
        // background: '#1A2038',
        //background: '#a3d0a9',
        background: 'linear-gradient(13deg, #accfe0, #aedce7);'
    },
    cardHolder_default: {
        // background: '#1A2038',
        //background: '#a3d0a9',
        background: 'linear-gradient(13deg, #ace0c1, #aedce7);'
    },
    card: {
        maxWidth: 800,
        borderRadius: 12,
        margin: '1rem',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    bottomRight: {
        position: 'fixed',
        bottom: '10px',
        right: ' 10px',
        color: '#848484'
    }
}))

const JwtLogin = () => {
    const [swasthaLoginPage, setSwasthaLoginPage] = useState(getEnv().SWASTHSA_COMMON_LOGIN_VIEW)
    const [loading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        email: '',
        password: '',
        totp: ''
    })
    const [message, setMessage] = useState('')
    const [selectUserRole, setSelectUserRole] = useState(false)
    const [selectedUserRole, setSelectedUserRole] = useState(null)
    const [userInfoRes, setUserInfoRes] = useState(null)
    const [otherUserRole, setOtherUserRole] = useState([])
    const [AllEmployeeInstitutions, setAllEmployeeInstitutions] = useState([])
    const [selectingInstititute, setSelectingInstititute] = useState(false)


    const [selectedInstitiute, setSelectedInstitiute] = useState(null)
    const [user, setUSer] = useState(null)
    const [userRolesFromKeycloak, setUserRolesFromKeycloak] = useState(null)
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const { login } = useAuth()

    const classes = useStyles()

    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userInfo }
        temp[name] = value
        setUserInfo(temp)
    }

    /*  useEffect(async () => {
         let envData = await getEnv()
         console.log("env data", envData)
         if (getEnv().SWASTHSA_COMMON_LOGIN_VIEW) {
             setSwasthaLoginPage(true)
         } else {
             setSwasthaLoginPage(false)
         }
     }, []) */

    const getOwnerId = async (userId) => {
        try {

            await localStorageService.setItem("store_id", null)

        } catch (error) {

        }
        let getAsignedEmployee = await EmployeeServices.getAsignEmployees({
            employee_id: userId,
            limit: 1,
            page: 0
        })
        console.log("getAsignedEmployee", getAsignedEmployee)

        let store_id_temp = getAsignedEmployee?.data?.view?.data[0]?.Pharmacy_drugs_store?.store_id;
        // let store_id_temp='1234'

        let params2 = { issuance_type: ["Hospital", "MSD Main", "RMSD Main"], limit: 1, page: 0, 'order[0]': ['createdAt', 'ASC'] }
        let getAsignedEmployeeHospital = await ClinicService.fetchAllClinicsNew(params2, store_id_temp);

        let store_id = null
        let main_hospital_id = null
        let pharmacy_drugs_stores = null
        if (getAsignedEmployee.status == 200) {
            console.log("asignEmp", getAsignedEmployee?.data?.view?.data)
            store_id = getAsignedEmployee?.data?.view?.data[0]?.Pharmacy_drugs_store?.store_id;
            main_hospital_id = getAsignedEmployeeHospital.data.view.data[0]?.id;
            let main_hospital_data = getAsignedEmployeeHospital.data.view.data[0];


            await localStorageService.setItem("store_id", store_id)
            await localStorageService.setItem("main_hospital_id", main_hospital_id)
            await localStorageService.setItem("main_hospital_data", main_hospital_data)

            let stored_store_id = await localStorageService.getItem('store_id')

            if (stored_store_id == null || stored_store_id == "null") {
                return false
            } else {
                return true
            }


        }
    }


    const loadAssignedInstitiutes = async (user_id) => {
        setLoading(true)
        try {
            let res = await EmployeeServices.getEmployeeInstitutions({ employee_id: user_id, status: 'Active' })
            console.log("getEmployeeInstitutions", res);



            let unique_institiutionList = uniqBy(res.data?.view?.data, 'pharmacy_drug_stores_id');

            setAllEmployeeInstitutions(unique_institiutionList)
            console.log("res data length", unique_institiutionList.length);
            if (unique_institiutionList?.length == 1) {
                //let ownerIdRes = await getOwnerId(user_id)
                let ownerIdRes = await getOwnerIdBySelectingInstitiute(user_id, unique_institiutionList[0].Pharmacy_drugs_store)
                //selectingUserInstitiute(res.data?.view?.data)
                let userRoles = await loadUserRolesByID(user_id, unique_institiutionList[0].Pharmacy_drugs_store.id)


                setOtherUserRole(userRoles)

                if (ownerIdRes) {
                    return { success: true, selectingInstitiute: false, userRoles: userRoles }
                } else {
                    window.localStorage.clear()
                    setMessage("User Institution Dose Not Exist. Please Try again!. If This Error Occurs Continuosly, Please Contact System Admin")
                    setLoading(false)
                    return { success: false, selectingInstitiute: false, userRoles: userRoles }
                }

            } else if (unique_institiutionList?.length != 0) {
                setSelectingInstititute(true)

                return { success: true, selectingInstitiute: true, userRoles: [] }
            } else {
                setMessage("User Institution Dose Not Exist. Please Try again!. If This Error Occurs Continuosly, Please Contact System Admin")
                setLoading(false)
                return { success: false, selectingInstitiute: false, userRoles: [] }
            }

        } catch (e) {
            console.log('error', e)
            setMessage(e.error_description)
            setLoading(false)
        }
    }



    const handleFormSubmit = async (event) => {
        setLoading(true)
        try {
            let res = await login(userInfo.email, userInfo.password, userInfo.totp)
            console.log("ress", res)

            if (res.error) {
                setMessage(res.message)
                setLoading(false)
            } else {
                let res_temp = res

                if (res_temp.roles.includes('Drug Store Keeper')) {
                    res_temp.roles[res_temp.roles.indexOf('Drug Store Keeper')] = 'Drugs Stores Pharmacist'
                }
                console.log("changed user roles", res_temp)
                setUSer(res_temp)
                setUserRolesFromKeycloak(res_temp.roles)
                let assignedInstitiute = await loadAssignedInstitiutes(res.id)


                if (assignedInstitiute.success) {
                    // let other_roles = res.roles;
                    let other_roles = assignedInstitiute.userRoles

                    let new_roles = []


                    //other_roles.splice(other_roles.indexOf('default-roles-swastharealm'), 1)
                    //other_roles.splice(other_roles.indexOf('offline_access'), 1)
                    //other_roles.splice(other_roles.indexOf('uma_authorization'), 1)
                    if (other_roles.includes('default-roles-swastharealm')) {
                        other_roles.splice(other_roles.indexOf('default-roles-swastharealm'), 1)
                    }
                    if (other_roles.includes('offline_access')) {
                        other_roles.splice(other_roles.indexOf('offline_access'), 1)
                    }
                    if (other_roles.includes('uma_authorization')) {
                        other_roles.splice(other_roles.indexOf('uma_authorization'), 1)
                    }



                    /*   for (let index = 0; index < other_roles.length; index++) {
                          const element = other_roles[index];
                          if (element == "Drug Store Keeper") {
                              new_roles.push({lable:"Drug Store Keeper",value:"Drug Store Keeper"})
                          }else{
                              new_roles.push({lable:element,value:element})
                          }
          
                      } */
                    console.log("asasadsa", assignedInstitiute.selectingInstitiute);
                    if (other_roles.includes('Drug Store Keeper')) {
                        console.log("role checked", other_roles.indexOf('Drug Store Keeper'))
                        other_roles[other_roles.indexOf('Drug Store Keeper')] = 'Drugs Stores Pharmacist'
                    }
                    if (assignedInstitiute.selectingInstitiute) {

                        setUserInfoRes(res)
                        setOtherUserRole(other_roles)
                        setSelectUserRole(true)
                    } else {
                        if (other_roles.length == 1) {

                            if (other_roles.includes('Drugs Stores Pharmacist')) {
                                other_roles[other_roles.indexOf('Drugs Stores Pharmacist')] = 'Drug Store Keeper'
                            }
                            res.roles = other_roles
                            if (res) {
                                await localStorageService.setItem("userInfo", res)
                            } else {
                                await localStorage.removeItem('userInfo')
                            }


                            history.push('/')
                        } else {
                            if (other_roles.includes('Drug Store Keeper')) {
                                console.log("role checked", other_roles.indexOf('Drug Store Keeper'))
                                other_roles[other_roles.indexOf('Drug Store Keeper')] = 'Drugs Stores Pharmacist'
                            }
                            setUserInfoRes(res)
                            setOtherUserRole(other_roles)
                            setSelectUserRole(true)
                        }
                    }


                } else {

                }





            }

            //history.push('/')
        } catch (e) {
            console.log('error', e)
            setMessage(e.error_description)
            setLoading(false)
        }
    }









    const saveUserRole = async () => {
        let selectedUserRoleNew = selectedUserRole;

        if (selectedUserRoleNew == 'Drugs Stores Pharmacist') {
            selectedUserRoleNew = 'Drug Store Keeper'
        }
        //let user_roles = [selectedUserRoleNew, 'uma_authorization', 'offline_access', 'default-roles-swastharealm']
        let user_roles = [selectedUserRoleNew]

        let user_info_res = userInfoRes;
        user_info_res.roles = user_roles;

        let otherUserRoles = otherUserRole
        if (otherUserRoles.includes('Drug Store Keeper')) {
            otherUserRoles[otherUserRoles.indexOf('Drug Store Keeper')] = 'Drugs Stores Pharmacist'
        }
        let allUserRoles = otherUserRoles.filter(item => userRolesFromKeycloak.includes(item))

        console.log("user all", userRolesFromKeycloak);
        console.log("user all otherUserRole", allUserRoles);

        if (user_info_res) {

            await localStorageService.setItem("userInfo", user_info_res)
            await localStorageService.setItem("all_user_roles", allUserRoles)
        }
        history.push('/')

    }


    const selectingUserInstitiute = async (value) => {
        setSelectedInstitiute(value)
        console.log("selected institiute", value);

        let ownerIdRes = await getOwnerIdBySelectingInstitiute(user.id, value?.Pharmacy_drugs_store)

        //setMessage("User Institution Dose Not Exist. Please Try again!. If This Error Occurs Continuosly, Please Contact System Admin")
        let userRoles = await loadUserRolesByID(user.id, value?.Pharmacy_drugs_store.id)
        if (userRoles.includes('Drug Store Keeper')) {
            console.log("role checked", userRoles.indexOf('Drug Store Keeper'))
            userRoles[userRoles.indexOf('Drug Store Keeper')] = 'Drugs Stores Pharmacist'
        }
        setOtherUserRole(userRoles)

        if (ownerIdRes) {
            return { success: true, selectingInstitiute: false }

        } else {
            window.localStorage.clear()
            setMessage("User Institution Dose Not Exist. Please Try again!. If This Error Occurs Continuosly, Please Contact System Admin")
            setLoading(false)
            setSelectUserRole(false)
            // return { success: false, selectingInstitiute: false }
        }
    }


    const getPharmacyDrugStore = async (userId, store_id) => {
        let getAsignedEmployee = await EmployeeServices.getAsignEmployees({
            employee_id: userId,
            store_id: store_id,
            limit: 1,
            page: 0
        })
        console.log("getAsignedEmployee", getAsignedEmployee)

        let PharmacyDrugStore = getAsignedEmployee?.data?.view?.data[0];
        return PharmacyDrugStore
    }



    const getOwnerIdBySelectingInstitiute = async (userId, drugs_store) => {
        try {

            await localStorageService.setItem("store_id", null)

        } catch (error) {

        }
        /*    let getAsignedEmployee = await EmployeeServices.getAsignEmployees({
               employee_id: userId,
               store_id: drugs_store.ownerId,
               limit: 1,
               page: 0
           }) */
        //console.log("getAsignedEmployee", getAsignedEmployee)

        //let store_id_temp = getAsignedEmployee?.data?.view?.data[0]?.Pharmacy_drugs_store?.store_id;
        let store_id_temp = drugs_store.store_id

        let pharmacyDrugStore = await getPharmacyDrugStore(userId, store_id_temp)


        let store_id = null
        let main_hospital_id = null
        console.log("asignEmp", pharmacyDrugStore)
        store_id = store_id_temp
        main_hospital_id = drugs_store.id;
        let main_hospital_data = drugs_store;
        drugs_store.pharmacy_drugs_stores_id = drugs_store.id;

        await localStorageService.setItem("store_id", store_id)
        await localStorageService.setItem("main_hospital_id", main_hospital_id)
        await localStorageService.setItem("main_hospital_data", main_hospital_data)

        let stored_store_id = await localStorageService.getItem('store_id')

        if (stored_store_id == null || stored_store_id == "null") {
            return false
        } else {
            return true
        }



    }

    const loadUserRolesByID = async (id, Pharmacy_drugs_store) => {
        let res = await EmployeeServices.getEmployeeAdditionalRoles({ employee_id: id, institute_id: Pharmacy_drugs_store });
        if (res.status == 200) {
            let roles = []
            console.log("user roles from token", user)
            res.data.view.data.forEach(element => {
                if (!roles.includes(element.role) && element.status != 'Deactive') {
                    roles.push(element.role)
                }

            });


            //    / let other_roles = roles.filter(item => user.roles.includes(item));
            console.log('user roles', roles)
            return roles
        }
    }

    return (
        <div
            className={clsx(
                'flex justify-center items-center  min-h-full-screen',
                swasthaLoginPage ? classes.cardHolder_default : classes.cardHolder
            )}
        >
            <Card className={classes.card}>
                <Grid container>
                    <Grid item lg={5} md={5} sm={5} xs={12}>



                        <div className="p-8 flex justify-center items-center h-full">
                            {swasthaLoginPage ?
                                <img
                                    className="w-200"
                                    src="/assets/images/main_logo.png"
                                    alt=""
                                />
                                :
                                <img
                                    className="w-200"
                                    src="/assets/images/main_logo.png"
                                    alt=""
                                />
                            }

                        </div>

                    </Grid>
                    <Grid item lg={7} md={7} sm={7} xs={12}>

                        <div className="p-8 h-full bg-light-gray relative">
                            {/* <Alert severity='error'>
                            <strong>Important ! Swastha system will be unavailable on 2023/11/19 from 1.00 a.m to 6.00 a.m due to a system upgrade.</strong>
                        </Alert> */}
                            <div className='mt-3'></div>
                            <ValidatorForm onSubmit={handleFormSubmit}>
                                <SubTitle title="Username" />
                                <TextValidator
                                    className="mb-3 w-full"
                                    variant="outlined"
                                    size="small"
                                    placeholder="Username"
                                    onChange={handleChange}
                                    type="text"
                                    name="email"
                                    value={userInfo.email}
                                    validators={['required']}
                                    errorMessages={[
                                        'This field is required',

                                    ]}
                                />

                                <SubTitle title="Password" />
                                <TextValidator
                                    className="w-full mb-3"
                                    placeholder="Password"
                                    variant="outlined"
                                    size="small"
                                    onChange={handleChange}
                                    name="password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={userInfo.password}
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                    //helperText="Enter your password here"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    size='small'
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />


                                {/*  <TextValidator
                                    className="mb-6 w-full"
                                    variant="outlined"
                                    size="small"
                                    label="OTP"
                                    onChange={handleChange}
                                    type="text"
                                    name="totp"
                                    value={userInfo.totp}
                                    validators={['required']}
                                    errorMessages={[
                                        'this field is required',

                                    ]}
                                /> */}
                                {/*  <FormControlLabel
                                    className="mb-3 min-w-288"
                                    name="agreement"
                                    onChange={handleChange}
                                    control={
                                        <Checkbox
                                            size="small"
                                            onChange={({
                                                target: { checked },
                                            }) =>
                                                handleChange({
                                                    target: {
                                                        name: 'agreement',
                                                        value: checked,
                                                    },
                                                })
                                            }
                                            checked={userInfo.agreement || true}
                                        />
                                    }
                                    label="Remeber me"
                                /> */}

                                {message && (
                                    <p className="text-error">{message}</p>
                                )}


                                <div className="flex flex-wrap items-center mb-4">
                                    <div className="relative">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={loading}
                                            type="submit"
                                        >
                                            Sign in
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    {/*  <span className="mr-2 ml-5">or</span>
                                    <Button
                                        className="capitalize"
                                        onClick={() =>
                                            history.push('/session/signup')
                                        }
                                    >
                                        Sign up
                                    </Button> */}
                                </div>
                                <Button
                                    className="text-primary"
                                    onClick={() =>
                                        history.push('/session/forgot-password')
                                    }
                                >
                                    Forgot password?
                                </Button>



                            </ValidatorForm>
                        </div>
                    </Grid>
                </Grid>
                {/* <div className='w-full flex justify-end px-2'> <div className='text-gray'>V {appConst.version}</div></div> */}
            </Card>


            <Dialog maxWidth="xs" open={selectUserRole} >
                <div className="p-8  w-450 mx-auto">
                    <Alert severity='info'>
                        <strong>Please Select User Role, Which is You Want to Login And Perform in the Session </strong>
                    </Alert>

                    <ValidatorForm onSubmit={() => { saveUserRole() }}>
                        <Grid container className='w-full'>
                            {selectingInstititute &&
                                <Grid className='w-full' item sm={12}>

                                    <Autocomplete
                                        disableClearable
                                        className="w-full"
                                        options={AllEmployeeInstitutions}
                                        onChange={(e, value) => {
                                            selectingUserInstitiute(value)
                                            setSelectedUserRole(null)
                                        }}
                                        value={selectedInstitiute}
                                        getOptionLabel={(option) => option.Pharmacy_drugs_store?.name}
                                        renderInput={(params) => (
                                            <TextValidator
                                                {...params}
                                                placeholder="Select Institiute"
                                                //variant="outlined"
                                                fullWidth
                                                variant="outlined"
                                                size="small"

                                                value={selectedInstitiute}
                                                validators={[
                                                    'required',
                                                ]}
                                                errorMessages={[
                                                    'this field is required',
                                                ]}
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                            <Grid className='w-full' item sm={12}>
                                <Autocomplete
                                    disableClearable
                                    className="w-full"
                                    options={otherUserRole.filter(item => user.roles.includes(item))}
                                    onChange={(e, value) => {
                                        setSelectedUserRole(value)

                                    }}
                                    value={selectedUserRole}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                        <TextValidator
                                            {...params}
                                            placeholder="User Role"
                                            //variant="outlined"
                                            fullWidth
                                            variant="outlined"
                                            size="small"

                                            value={selectedUserRole}
                                            validators={[
                                                'required',
                                            ]}
                                            errorMessages={[
                                                'this field is required',
                                            ]}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>





                        <Button
                            variant="contained"
                            className='mt-2'
                            color="primary"
                            //disabled={loading}
                            type="submit"
                        >
                            Save
                        </Button>
                    </ValidatorForm>

                </div>
            </Dialog>



            <div className={classes.bottomRight}>
                V {appConst.version}
            </div>
        </div>
    )
}

export default JwtLogin
